import { BearingEnvelope, ModelCategory } from '@paragon/contract-library';

import { ModelSchema } from '../ModelSchema';
import { CeilingPlaneSchema } from './CeilingPlaneSchema';
import { RoofPlaneSchema } from './RoofPlaneSchema';

interface BearingEnvelopeSchemaOptions {
  displayName: (envelope: BearingEnvelope) => string;
  pluralName: string;
}

export function createBearingEnvelopeSchema(type: 'beam' | 'wall', options: BearingEnvelopeSchemaOptions) {
  return new ModelSchema<BearingEnvelope>(type, {
    category: ModelCategory.IntermediateModel,
    displayName: options.displayName,
    pluralName: options.pluralName,
    properties: {},
    children: {
      roofPlanes: RoofPlaneSchema,
      ceilingPlanes: CeilingPlaneSchema,
    },
  });
}
